/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum LocationServiceErrorMessages {
  USER_DECLINED = 'User declined to allow browser geolocation',
  IP_GEOLOCATION_FAILED = 'Failed to get IP geolocation',
  VISITOR_LOCATOR_UNDEFINED = 'Instance of visitor locator service is undefined',
}
